import HelpCenter from './helpCenter'
import { createRouter, createWebHistory } from 'vue-router'
import { operatorRoute } from './operator'

export default createRouter({
  history: createWebHistory(),
  routes: [
    {
      path: "/",
      name: "home",
      component: () => import('../pages/home/index.vue'),
      children: [
        {
          path: "/404",
          name: "404",
          component: () => import('../pages/404.vue'),
          meta: {
            title: 'Not Found - ArtemisAds'
          }
        }
      ],
    },
    {
      path: "/seller",
      name: "seller",
      redirect: '/seller/product',
      component: () => import('../pages/seller/index.vue'),
      meta: {
        requiresAUserType: 'seller'
      },
      children: [
        {
          path: 'pay-result',
          name: 'seller-pay-result',
          component: () => import('../pages/seller/payResult/index.vue'),
          meta: {
            title: 'Pay Result - ArtemisAds',
            titleKey: 'seller.pageTitle.payResult',
            hiddenNav: true
          }
        },
        {
          path: 'invoice-pdf/:id',
          name: 'seller-invoice-pdf',
          component: () => import('../pages/seller/pdf.vue'),
          meta: {
            title: 'Finance Invoice PDF - ArtemisAds',
            titleKey: 'seller.pageTitle.financeInvoicePdf',
          }
        },
        {
          path: 'merge-pdf/:id',
          name: 'seller-merge-pdf',
          component: () => import('../pages/seller/mergePdf.vue'),
          meta: {
            title: 'Finance Invoice PDF - ArtemisAds',
            titleKey: 'seller.pageTitle.financeInvoicePdf',
          }
        },
        {
          path: 'campaigns-invoice-pdf/:id',
          name: 'campaigns-invoice-pdf',
          component: () => import('../pages/seller/Settings/campaigns/components/pdf.vue'),
          meta: {
            title: 'Finance Invoice PDF - ArtemisAds',
            titleKey: 'seller.pageTitle.financeInvoicePdf',
          }
        },
        {
          path: "finance",
          name: "seller finance",
          redirect: '/seller/finance/payments',
          meta: {
            title: 'Finance - ArtemisAds',
            titleKey: 'seller.pageTitle.finance',
          },
          children: [
            {
              path: "payments",
              name: "seller finance payments",
              component: () => import('../pages/seller/finance/payments/home/index.vue'),
              meta: {
                title: 'Finance Payments - ArtemisAds',
                titleKey: 'seller.pageTitle.financePayments',
              }
            },
            {
              path: "paymentMethod",
              name: "seller finance paymentMethod",
              component: () => import('../pages/seller/finance/paymentMethod/index.vue'),
              meta: {
                title: 'PaymentMethod - ArtemisAds',
              },
            },
          ]
        },
        {
          path: "reports",
          name: "seller reports",
          redirect: '/seller/reports/performance',
          meta: {
            title: 'Reports - ArtemisAds',
            titleKey: 'seller.pageTitle.reports',
          },
          children: [
            {
              path: "performance",
              name: "seller reports performance",
              component: () => import('../pages/seller/reports/performance/index.vue'),
              meta: {
                title: 'Performance Reports - In ArtemisAds',
                titleKey: 'seller.pageTitle.reportsPerformance',
              }
            },
            {
              path: "brand",
              name: "seller reports brand",
              component: () => import('../pages/seller/reports/brand/index.vue'),
              meta: {
                title: 'Brand Reports - In ArtemisAds',
                titleKey: 'seller.pageTitle.reportsBrand',
              }
            },
            {
              path: "product",
              name: "seller reports product",
              component: () => import('../pages/seller/reports/product/index.vue'),
              meta: {
                title: 'Product Reports - In ArtemisAds',
                titleKey: 'seller.pageTitle.reportsProduct',
              }
            },
            {
              path: "publisher",
              name: "seller reports publisher",
              component: () => import('../pages/seller/reports/publisher/index.vue'),
              meta: {
                title: 'Publisher Reports - In ArtemisAds',
                titleKey: 'seller.pageTitle.reportsPublisher',
              }
            },
          ]
        },
        {
          path: "dashboard",
          name: "seller dashboard",
          component: () => import('../pages/seller/dashboard/index.vue'),
          meta: {
            title: 'Dashboard - ArtemisAds',
            titleKey: 'seller.pageTitle.dashboard',
          }
        },
        {
          path: "cpc",
          name: "seller cpc",
          component: () => import('../pages/seller/cpc/index.vue'),
          meta: {
            title: 'CPC - ArtemisAds',
          }
        },
        {
          path: "cpc/create",
          name: "seller cpc create",
          component: () => import('../pages/seller/cpc/create.vue'),
          meta: {
            title: 'Create CPC Campaign - ArtemisAds',
          }
        },
        {
          path: "cpc/:id",
          name: "seller cpc detail",
          component: () => import('../pages/seller/cpc/detail.vue'),
          meta: {
            title: 'CPC Campaign Details - ArtemisAds',
          }
        },
        // {
        //   path: "welcome",
        //   name: "welcome",
        //   component: () => import('../pages/seller/dashboard/index.vue'),
        //   meta: {
        //     title: 'Welcome - ArtemisAds',
        //   }
        // },
        {
          path: "product",
          name: "product",
          component: () => import('../pages/seller/product/index.vue'),
          meta: {
            title: 'Product - ArtemisAds',
            titleKey: 'seller.pageTitle.product',
            namePath: ['product'],
            label: 'Products'
          }
        },
        {
          path: 'brand',
          name: "brand",
          redirect: '/seller/brand/index',
          meta: {
            title: 'Brands - ArtemisAds',
            titleKey: 'seller.pageTitle.brands',
            namePath: ['brand'],
            label: 'Brands'
          },
          children: [
            {
              path: 'index',
              name: 'brandList',
              component: () => import('../pages/seller/Brands/index.vue'),
              meta: {
                title: 'Brands - ArtemisAds',
                titleKey: 'seller.pageTitle.brands',
                namePath: ['brand', 'brandList'],
                label: 'Brands',
                isNotShowMenu: true
              }
            },
            {
              path: "detail/:id",
              name: "brandDetail",
              component: () => import('../pages/seller/Brands/detail.vue'),
              meta: {
                title: 'Brands - ArtemisAds',
                titleKey: 'seller.pageTitle.brands',
                namePath: ['brand', 'brandDetail'],
                label: 'Brand Name'
              }
            }
          ]
        },
        {
          path: "product/:id",
          name: "Seller Product Detail",
          component: () => import('../pages/seller/product/detail/index.vue'),
          meta: {
            title: 'Product - ArtemisAds',
            titleKey: 'seller.pageTitle.productDetail',
          }
        },
        {
          path: 'connection',
          name: 'sl-connection',
          component: () => import('../pages/seller/Settings/connections.vue'),
          meta: {
            title: 'Connections - ArtemisAds',
            titleKey: 'seller.pageTitle.connections',
          }
        },
        {
          path: "Settings/paidPlacement/campaigns",
          name: "settings-paidCampaigns-campaigns",
          component: () => import('../pages/seller/Settings/campaigns/index.vue'),
          meta: {
            title: 'Settings "Paid campaigns - ArtemisAds',
            titleKey: 'seller.pageTitle.paidCampaigns',
          },
        },
        
        {
          path: "Settings/paidPlacement/campaigns/:id",
          name: "settings-paidPlacement-campaigns-details",
          component: () => import('../pages/seller/Settings/campaigns/details.vue'),
          meta: {
            title: 'Campaign Details - ArtemisAds',
            titleKey: 'seller.pageTitle.campaignDetails',
          },
        },
        {
          path: "Settings/paidPlacement/placement",
          name: "settings-paidCampaigns-placement",
          component: () => import('../pages/seller/Settings/placement/index.vue'),
          meta: {
            title: 'Settings "Paid Placement - ArtemisAds',
            titleKey: 'seller.pageTitle.paidPlacement',
          },
        },
        {
          path: "Settings/paidPlacement/placement/:id",
          name: "settings-paidPlacement-placement-details",
          component: () => import('../pages/seller/Settings/placement/details.vue'),
          meta: {
            title: 'Placement Details - ArtemisAds',
            titleKey: 'seller.pageTitle.placementDetails',
          },
        },
        {
          path: 'account-info',
          name: 'sl-account-info',
          component: () => import('../pages/seller/Settings/accountInfo/index.vue'),
          meta: {
            title: 'Account Info - ArtemisAds',
            titleKey: 'seller.pageTitle.accountInfo',
          }
        },
        {
          path: 'whitelist',
          name: 'sl-whitelist',
          component: () => import('../pages/seller/Settings/whitelist/index.vue'),
          meta: {
            title: 'Whitelist - ArtemisAds',
            titleKey: 'seller.pageTitle.whitelist',
          }
        },
        {
          path: 'commission-rule',
          name: 'sl-commission-rule',
          component: () => import('../pages/seller/Settings/commissionRule/index.vue'),
          meta: {
            title: 'Commission Rule - ArtemisAds',
            titleKey: 'seller.pageTitle.commissionRule',
          }
        },
        {
          path: 'users-permissions',
          name: 'sl-users-permissions',
          component: () => import('../pages/public/UsersAndPermissions.vue'),
          meta: {
            title: 'Users & Permissions - ArtemisAds',
            titleKey: 'seller.pageTitle.usersPermissions',
          }
        },
        {
          path: "referral",
          name: 'Referral  - ArtemisAds',
          component: () => import('../pages/referral/index.vue'),
          meta: {
            title: 'Referral - ArtemisAds',
            titleKey: 'seller.pageTitle.referral',
          }
        },
        {
          path: "publishers",
          name: "Publishers  - ArtemisAds",
          component: () => import('../pages/seller/Publishers/index.vue'),
          meta: {
            title: 'Publishers - ArtemisAds',
            titleKey: 'seller.pageTitle.publishers',
            namePath: ['publishers'],
          },
        },
        {
          path: "publishers/:id",
          name: "Seller Publisher Detail",
          component: () => import('../pages/seller/Publishers/detail.vue'),
          meta: {
            title: 'Publisher - ArtemisAds',
            titleKey: 'seller.pageTitle.publisherDetail',
          }
        },
        {
          path: "sellerAccount",
          name: "Seller Account",
          component: () => import('../pages/seller/sellerAccount/authorization.vue'),
          meta: {
            title: 'Account - ArtemisAds',
            titleKey: 'seller.pageTitle.sellerAccount',
          }
        },

        {
          path: "sellerAccount/authorization/guide",
          name: "sellerAccount-authorization-guide",
          component: () => import('../pages/seller/sellerAccount/authorizationGuide.vue'),
          meta: {
            title: 'Authorization Guide - ArtemisAds',
            titleKey: 'seller.pageTitle.authorizationGuide',
          }
        },
        {
          path: "associateCentral",
          name: "seller associateCentral",
          redirect: '/seller/associateCentral',
          meta: {
            title: 'Associate Central - ArtemisAds',
            titleKey: 'seller.pageTitle.associateCentral',
          },
          children: [
            {
              path: "brands",
              name: "seller associateCentral brands",
              component: () => import('../pages/seller/associateCentral/brands/index.vue'),
              meta: {
                title: 'Associate Central - Brands - ArtemisAds',
                titleKey: 'seller.pageTitle.acBrands',
              }
            },
            {
              path: "product",
              name: "seller associateCentral product",
              component: () => import('../pages/seller/associateCentral/product/index.vue'),
              meta: {
                title: 'Associate Central - Product - ArtemisAds',
                titleKey: 'seller.pageTitle.acProduct',
              }
            },
            {
              path: "publishers",
              name: "seller associateCentral publishers",
              component: () => import('../pages/seller/associateCentral/publishers/index.vue'),
              meta: {
                title: 'Associate Central - Publishers - ArtemisAds',
                titleKey: 'seller.pageTitle.acPublishers',
              }
            },
            {
              path: "campaigns",
              name: "seller associateCentral campaigns",
              component: () => import('../pages/seller/sellerAccount/campaigns.vue'),
              meta: {
                title: 'Campaigns - ArtemisAds',
                titleKey: 'seller.pageTitle.campaigns',
              }
            },
            {
              path: "authorization",
              name: "seller associateCentral authorization",
              component: () => import('../pages/seller/sellerAccount/authorization.vue'),
              meta: {
                title: 'Authorization - ArtemisAds',
                titleKey: 'seller.pageTitle.authorization',
              }
            },
            {
              path: "setUpAssociatePartnership",
              name: "seller associateCentral setUpAssociatePartnership",
              component: () => import('../pages/seller/associateCentral/publishers/setUpAssociatePartnership.vue'),
              meta: {
                title: 'Associate Central - Publishers - ArtemisAds',
                titleKey: 'seller.pageTitle.acPublishers',
              }
            },
            {
              path: "setUpAssociatePartnershipMultiple",
              name: "seller associateCentral setUpAssociatePartnershipMultiple",
              component: () => import('../pages/seller/associateCentral/publishers/setUpAssociatePartnershipMultiple.vue'),
              meta: {
                title: 'Associate Central - Publishers - ArtemisAds',
                titleKey: 'seller.pageTitle.acPublishers',
              }
            },
            {
              path: "setUpAssociatePartnershipBrands",
              name: "seller associateCentral setUpAssociatePartnershipBrands",
              component: () => import('../pages/seller/associateCentral/brands/setUpAssociatePartnership.vue'),
              meta: {
                title: 'Associate Central - Brands - ArtemisAds',
                titleKey: 'seller.pageTitle.acBrands',
              }
            },
            {
              path: "reports",
              name: "seller associateCentral reports",
              redirect: '/seller/associateCentral/reports/performance',
              meta: {
                title: 'Reports - ArtemisAds',
                titleKey: 'seller.pageTitle.acReports',
              },
              children: [
                {
                  path: "performance",
                  name: "seller associateCentral reports performance",
                  component: () => import('../pages/seller/associateCentral/reports/performance/index.vue'),
                  meta: {
                    title: 'Performance Reports - In ArtemisAds',
                    titleKey: 'seller.pageTitle.acReportsPerformance',
                  }
                },
                {
                  path: "brand",
                  name: "seller associateCentral reports brand",
                  component: () => import('../pages/seller/associateCentral/reports/brand/index.vue'),
                  meta: {
                    title: 'Brand Reports - In ArtemisAds',
                    titleKey: 'seller.pageTitle.acReportsBrand',
                  }
                },
                {
                  path: "product",
                  name: "seller associateCentral reports product",
                  component: () => import('../pages/seller/associateCentral/reports/product/index.vue'),
                  meta: {
                    title: 'Product Reports - In ArtemisAds',
                    titleKey: 'seller.pageTitle.acReportsProduct',
                  }
                },
                {
                  path: "publisher",
                  name: "seller associateCentral reports publisher",
                  component: () => import('../pages/seller/associateCentral/reports/publisher/index.vue'),
                  meta: {
                    title: 'Publisher Reports - In ArtemisAds',
                    titleKey: 'seller.pageTitle.acReportsPublisher',
                  }
                },
              ]
            },
            {
              path: "partnerships",
              name: "seller associateCentral partnerships",
              component: () => import('../pages/seller/associateCentral/Partnerships/index.vue'),
              meta: {
                title: 'Partnerships - ArtemisAds',
                titleKey: 'seller.pageTitle.partnerships',
              }
            }
          ]
        },
        {
          path: "creatorConnections",
          name: "seller creatorConnections",
          redirect: '/seller/creatorConnections/accBonusProgram',
          meta: {
            title: 'Creator Connections - ArtemisAds',
            titleKey: 'seller.pageTitle.creatorConnections',
          },
          children: [
            {
              path: "accBonusProgram",
              name: "seller creatorConnections accBonusProgram",
              component: () => import('../pages/seller/creatorConnections/accBonusProgram/index.vue'),
              meta: {
                title: 'Creator Connections - Acc Bonus Program - ArtemisAds',
                titleKey: 'seller.pageTitle.creatorConnectionsAccBonusProgram',
              }
            },
            {
              path: "authorization",
              name: "seller creatorConnections authorization",
              component: () => import('../pages/seller/sellerAccount/authorization.vue'),
              meta: {
                title: 'Authorization - ArtemisAds',
                titleKey: 'seller.pageTitle.authorization',
              }
            },
            {
              path: "campaigns",
              name: "seller creatorConnections campaigns",
              component: () => import('../pages/seller/sellerAccount/campaigns.vue'),
              meta: {
                title: 'Campaigns - ArtemisAds',
                titleKey: 'seller.pageTitle.campaigns',
              }
            },
            {
              path: "accCreact",
              name: "seller creatorConnections accCreact",
              component: () => import('../pages/seller/creatorConnections/creact/index.vue'),
              meta: {
                title: 'Creator Connections - Acc Creact - ArtemisAds',
                titleKey: 'seller.pageTitle.creatorConnectionsAccCreact',
              }
            },
            {
              path: "accBonusProgram/view/:id",
              name: "seller creatorConnections accBonusProgram view",
              component: () => import('../pages/seller/creatorConnections/accBonusProgram/view.vue'),
              meta: {
                title: 'Creator Connections - Acc Bonus Program View - ArtemisAds',
                titleKey: 'seller.pageTitle.creatorConnectionsAccBonusProgramView',
              }
            }
          ]
        }
      ],
    },


    // {
    //   path: "/mail",
    //   name: "/mail",
    //   component: () => import('../pages/mailTemplate/mail.vue'),
    //   meta: {
    //     title: 'mail - ArtemisAds',
    //   }
    // },
    // {
    //   path: "/publisher-rejected-email",
    //   name: "/publisher-rejected-email",
    //   component: () => import('../pages/mailTemplate/publisher-rejected-email.vue'),
    //   meta: {
    //     title: 'mail - ArtemisAds',
    //   }
    // },
    // {
    //   path: "/publisher-approved-email",
    //   name: "/publisher-approved-email",
    //   component: () => import('../pages/mailTemplate/publisher-approved-email.vue'),
    //   meta: {
    //     title: 'mail - ArtemisAds',
    //   }
    // },
    {
      path: "/terms-of-service",
      name: "/Terms Of Service",
      component: () => import('../pages/termsOfService/index.vue'),
      meta: {
        title: 'Terms Of Service - ArtemisAds',
      }
    },
    {
      path: "/privacy-policy",
      name: "/Privacy Policy",
      component: () => import('../pages/privacyPolicy/index.vue'),
      meta: {
        title: 'Privacy Policy - ArtemisAds',
      }
    },
    {
      path: "/delegation-invitation",
      name: "Delegation Invitation",
      component: () => import('../pages/public/delegateUserSignin.vue'),
      meta: {
        title: 'Delegation Invitation - ArtemisAds',
      }
    },
    {
      path: "/sign-in",
      name: "sign-in",
      component: () => import('../pages/signIn/index.vue'),
      meta: {
        title: 'Sign In - ArtemisAds',
      }
    },
    {
      path: "/sign-up",
      name: "sign-up",
      component: () => import('../pages/signUp/index.vue'),
      meta: {
        title: 'Sign Up - ArtemisAds'
      }
    },
    {
      path: "/find-password",
      name: "find-password",
      component: () => import('../pages/forget/index.vue'),
      meta: {
        title: 'Find password - ArtemisAds'
      }

    },
    {
      path: "/reset-password",
      name: "reset-password",
      component: () => import('../pages/forget/resetPassword.vue'),
      meta: {
        title: 'Reset password - ArtemisAds'
      }
    },
    {
      path: "/profile",
      name: "profile",
      component: () => import('../pages/profile/index.vue'),
      meta: {
        title: 'Profile - ArtemisAds',
      }
    },
    {
      path: "/publisher",
      name: "Publisher",
      redirect: '/publisher/products',
      component: () => import('../pages/publisher/index.vue'),
      meta: {
        requiresAUserType: 'publisher'
      },
      children: [
        {
          path: 'invoice-pdf/:id',
          name: 'publisher-invoice-pdf',
          component: () => import('../pages/publisher/pdf.vue'),
          meta: {
            title: 'Finance Invoice PDF - ArtemisAds',
          }
        },

        {
          path: "finance",
          name: "publisher finance",
          redirect: '/publisher/finance/payments',
          meta: {
            title: 'Finance - ArtemisAds',
          },
          children: [
            {
              path: "payments",
              name: "publisher finance payments",
              component: () => import('../pages/publisher/finance/payments/home/index.vue'),
              meta: {
                title: 'Finance Payments - ArtemisAds',
              }
            },
          ]
        },
       
        {
          path: "dashboard",
          name: "publisher dashboard",
          component: () => import('../pages/publisher/dashboard/index.vue'),
          meta: {
            title: 'Dashboard - ArtemisAds',
          }
        },
        {
          path: "reports",
          name: "publisher reports",
          redirect: '/publisher/reports/performance',
          meta: {
            title: 'Reports - In ArtemisAds',
          },
          children: [
            {
              path: "performance",
              name: "publisher reports performance",
              component: () => import('../pages/publisher/reports/performance/index.vue'),
              meta: {
                title: 'Performance Reports - In ArtemisAds',
              }
            },
            {
              path: "brand",
              name: "publisher reports brand",
              component: () => import('../pages/publisher/reports/brand/index.vue'),
              meta: {
                title: 'Brand Reports - In ArtemisAds',
              }
            },
            {
              path: "product",
              name: "publisher reports product",
              component: () => import('../pages/publisher/reports/product/index.vue'),
              meta: {
                title: 'Product Reports - In ArtemisAds',
              }
            },
            {
              path: "trackingId",
              name: "TrackingId reports",
              component: () => import('../pages/publisher/reports/trackingId/index.vue'),
              meta: {
                title: 'TrackingId Id Reports',
              }
            }
          ]
        },
        {
          path: "products",
          name: "Products",
          component: () => import('../pages/publisher/products/index.vue'),
          meta: {
            title: "Products - Artemis Ads",
          }
        },
        {
          path: "brands",
          name: "Brands",
          component: () => import('../pages/publisher/brands/index.vue'),
          meta: {
            title: "Brands - Artemis Ads",
          }
        },
        {
          name: "Links",
          path: "links/:type",
          component: () => import('../pages/publisher/links/index.vue'),
          meta: {
            // 默认标题会根据 type 动态修改
            title: 'My Product Links - Artemis Ads'
          },
        },
        {
          path: "products/:id",
          name: "Product Detail",
          component: () => import('../pages/publisher/products/detail/index.vue'),
          meta: {
            title: "Product Detail - Artemis Ads",
          }
        },
        {
          path: "brands/:id",
          name: "Brand Detail",
          component: () => import('../pages/publisher/brands/detail.vue'),
          meta: {
            title: "Brand Detail - ArtemisAds",
          }
        },
        {
          path: "settings",
          name: "Settings - ArtemisAds",
          redirect: '/publisher/settings/profile',
          meta: {
            title: "Settings - ArtemisAds"
          },
          children: [
            {
              path: "profile",
              name: "Profile - Artemis Ads",
              component: () => import('../pages/publisher/settings/profile/index.vue'),
              meta: {
                title: 'Settings Profile - ArtemisAds',
              }
            },
            {
              path: "open-api",
              name: "Open API - Artemis Ads",
              component: () => import('../pages/publisher/settings/openAPI/index.vue'),
              meta: {
                title: 'Settings "Open API - ArtemisAds',
              }
            },
            {
              path: 'users-permissions',
              name: 'publisher-users-permissions',
              component: () => import('../pages/public/UsersAndPermissions.vue'),
              meta: {
                title: 'Users & Permissions - ArtemisAds',
              }
            },
            {
              path: "tracking-ids",
              name: "Tracking IDs - Artemis Ads",
              component: () => import('../pages/publisher/settings/trackingIds/index.vue'),
              meta: {
                title: 'Settings "Tracking IDs - ArtemisAds',
              }
            },
            {
              path: "associateTags",
              name: "Associate Tags - Artemis Ads",
              component: () => import('../pages/publisher/settings/associateTags/index.vue'),
              meta: {
                title: 'Settings "Associate Tags - ArtemisAds',
              }
            },
            {
              path: "paidPlacement",
              name: "settings-paidPlacement",
              component: () => import('../pages/publisher/settings/campaigns/index.vue'),
              meta: {
                title: 'Settings "Paid Placement - ArtemisAds',
              },
            },
            {
              path: "paidPlacement/campaigns",
              name: "settings-paidPlacement-campaigns",
              component: () => import('../pages/publisher/settings/campaigns/index.vue'),
              meta: {
                title: 'Campaigns - ArtemisAds',
              },
            },
            {
              path: "paidPlacement/campaigns/:id",
              name: "Campaigns Details - Artemis Ads",
              component: () => import('../pages/publisher/settings/campaigns/details.vue'),
              meta: {
                title: 'Campaign Details - ArtemisAds',
              },
            },
            {
              path: "paidPlacement/placement",
              name: "settings-paidPlacement-placement",
              component: () => import('../pages/publisher/settings/placement/index.vue'),
              meta: {
                title: 'Placement - ArtemisAds',
              },
            },
            
          ]
        },
       
        {
          path: "referral",
          name: 'Referral - ArtemisAds',
          component: () => import('../pages/referral/index.vue'),
          meta: {
            title: 'Referral - ArtemisAds',
          }
        },
        {
          path: "associateCentral",
          name: "associateCentral",
          redirect: '/publisher/associateCentral/uploadReports',
          meta: {
            title: 'Associate Central - ArtemisAds',
          },
          children: [
            {
              path: "uploadReports",
              name: "associateCentral-uploadReports",
              component: () => import('../pages/publisher/associateCentral/uploadReports/index.vue'),
              meta: {
                title: 'Upload Reports - ArtemisAds',
              }
            },
            {
              path: "associateBrands",
              name: "associateCentral-associateBrands",
              component: () => import('../pages/publisher/associateCentral/associateBrands/index.vue'),
              meta: {
                title: 'Associate Brands - ArtemisAds',
              }
            },
            {
              path: "associateTags",
              name: "associateCentral-associateTags",
              component: () => import('../pages/publisher/associateCentral/associateTags/index.vue'),
              meta: {
                title: 'Associate Tags - ArtemisAds',
              }
            },
            {
              path: "creatorConnections",
              name: "associateCentral-creatorConnections",
              redirect: '/publisher/associateCentral/creatorConnections/allCampaigns',
              meta: {
                title: 'Creator Connections - ArtemisAds',
              },
              children: [
                {
                  path: "allCampaigns",
                  name: "associateCentral-creatorConnections-allCampaigns",
                  component: () => import('../pages/publisher/associateCentral/creatorConnections/allCampaigns.vue'),
                  meta: {
                    title: 'All Campaigns - ArtemisAds',
                  }
                }
              ]
            },

          ]
        },
        {
          path: "campaigns",
          name: "Cost-Per-Click",
          redirect: '/publisher/campaigns/index',
          meta: {
            title: 'Campaigns - ArtemisAds',
          },
          children: [
            {
              path: "index",
              name: "publisher campaigns index",
              component: () => import('../pages/publisher/campaigns/index.vue'),
              meta: {
                title: 'Cost-Per-Click - ArtemisAds',
              }
            },
            {
              path: "details/:id",
              name: "publisher campaigns details",
              component: () => import('../pages/publisher/campaigns/details.vue'),
              meta: {
                title: 'Campaign Details - ArtemisAds',
              }
            },
            {
              path: "myCampaigns",
              name: "publisher campaigns myCampaigns",
              component: () => import('../pages/publisher/campaigns/myCampaigns.vue'),
              meta: {
                title: 'My Campaigns - ArtemisAds',
              }
            },
            {
              path: "upload",
              name: "publisher campaigns upload",
              component: () => import('../pages/publisher/campaigns/uploadReports/index.vue'),
              meta: {
                title: 'Upload - ArtemisAds',
              }
            }
          ]
        },
        {
          path: "creatorConnections",
          name: "publisher creatorConnections",
          redirect: '/publisher/creatorConnections/allCampaigns',
          meta: {
            title: 'Creator Connections - ArtemisAds',
          },
          children: [
            {
              path: "allCampaigns",
              name: "publisher creatorConnections allCampaigns",
              component: () => import('../pages/publisher/creatorConnections/allCampaigns.vue'),
              meta: {
                title: 'All Campaigns - ArtemisAds',
              }
            },
            {
              path:'bonusPrograms',
              name: 'publisher creatorConnections bonusPrograms',
              component: () => import('../pages/publisher/creatorConnections/bonusPrograms.vue'),
              meta: {
                title: 'Bonus Programs - ArtemisAds',
              }
            },
            {
              path:"programdetails/:id",
              name: 'publisher creatorConnections programdetails',
              component: () => import('../pages/publisher/creatorConnections/programdetails.vue'),
              meta: {
                title: 'Program Details - ArtemisAds',
              }
            },
            {
              path: "associateTags",
              name: "Amazon StoreID - Artemis Ads",
              component: () => import('../pages/publisher/creatorConnections/associateTags/index.vue'),
              meta: {
                title: 'Amazon StoreID - ArtemisAds',
              }
            },
          ]
        }
      ]
    },
    {
      // cooperator路由
      path: "/products",
      name: "products",
      component: () => import('../pages/public/cooperator/index.vue'),
      meta: {
        title: 'Management Platform - ArtemisAds',
      }
    },
    operatorRoute,
    {
      path: "/operator/login",
      name: "op_login",
      component: () => import('../pages/operator/login/index.vue'),
      meta: {
        title: 'Login - ArtemisAds Op',
      }
    },
    { ...HelpCenter },
  ],
})